var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import DropDownDivider from "./DropDownDivider";
import DropDownItem from "./DropDownItem";
import { Button } from "../Button";
import { Popover } from "../Popover";
// styles
import "./dropDown.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    className: undefined,
    id: undefined,
    style: undefined,
    "data-testid": "tecma-DropDown",
    position: { vertical: "bottom", horizontal: "center" },
    transformOrigin: { vertical: "top", horizontal: "center" },
    iconOnOpen: "arrow-up",
    iconOnClose: "arrow-down",
};
/**
 * A menu in which options are hidden by default but can be shown by interacting with a button.
 */
const DropDown = (_a) => {
    var { className, children, isOpen, position, transformOrigin, onToggle, triggerProps, iconOnOpen, iconOnClose, trigger, rotateIconOnToggle } = _a, rest = __rest(_a, ["className", "children", "isOpen", "position", "transformOrigin", "onToggle", "triggerProps", "iconOnOpen", "iconOnClose", "trigger", "rotateIconOnToggle"]);
    const classList = classNames("tecma-dropDown", { isOpen }, className);
    const triggerClassName = triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.className;
    const triggerClassList = classNames("dropDown-trigger", {
        isOpen,
        "rotate-icon-on-toggle": rotateIconOnToggle,
        [`${triggerClassName}`]: triggerClassName,
    });
    const triggerIcon = (() => {
        if (rotateIconOnToggle) {
            return iconOnClose;
        }
        return isOpen ? iconOnOpen : iconOnClose;
    })();
    const dropDownTrigger = (() => {
        if (triggerProps) {
            return (_jsx(Button, Object.assign({ iconName: triggerIcon, rightIcon: true }, triggerProps, { className: triggerClassList })));
        }
        return null;
    })();
    return (_jsx(Popover, Object.assign({ isOpen: isOpen, position: position, transformOrigin: transformOrigin, onClose: onToggle, trigger: trigger || dropDownTrigger, className: classList }, rest, { children: _jsx("ul", { children: children }) })));
};
DropDown.defaultProps = defaultProps;
const DropDownSpace = Object.assign(DropDown, {
    Item: DropDownItem,
    Divider: DropDownDivider,
});
export { DropDownSpace as DropDown };
